// src/components/products/picobox/PicoBoxFeatures.jsx
import React from "react";
import RichTextRenderer from "../../common/RichTextRenderer";
import ProductContainerImage from "../ProductContainerImage";
import {
  PRODUCT_DETAIL_BODY_TEXT,
  PRODUCT_DETAIL_CONTENT_WRAP,
} from "../../../utils/productDetailTypography";

const PicoBoxFeatures = ({
  title,
  content,
  imageUrl,
  imageSubtitle,
  safeText,
}) => {
  if (!title) return null;

  return (
    <div className="mb-12 md:mb-16">
      <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
        {/* Features Title Bar - Full Width Background */}
        <div className="product-panel-header">
          <h2>
            {safeText(title)}
          </h2>
        </div>

        {/* Features Content and Image */}
        <div className="p-6 sm:p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
            {/* Features Content - ?�??��? */}
            {content && (
              <div className="flex-1">
                <div className={PRODUCT_DETAIL_CONTENT_WRAP}>
                  {Array.isArray(content) ? (
                    <RichTextRenderer
                      content={content}
                      textColorClass="text-gray-700"
                      linkColorClass="product-link text-lg lg:text-xl"
                      bodyTextClass={PRODUCT_DETAIL_BODY_TEXT}
                      compactHeadings
                    />
                  ) : (
                    <div
                      className={`${PRODUCT_DETAIL_BODY_TEXT} whitespace-pre-line text-gray-700`}
                    >
                      {safeText(content)}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Features Image - ?��??��? */}
            {imageUrl && (
              <div className="flex w-full flex-shrink-0 flex-col items-center lg:w-auto lg:items-end">
                <ProductContainerImage
                  src={imageUrl}
                  alt={imageSubtitle || "Features"}
                />
                {imageSubtitle && (
                  <p className="mt-4 text-center text-sm font-medium text-gray-600 sm:text-base">
                    {safeText(imageSubtitle)}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PicoBoxFeatures;


